import NaptimeResource from './NaptimeResource';

class PaymentProcessorClientTokens extends NaptimeResource {
  static RESOURCE_NAME = 'paymentProcessorClientTokens.v1';

  get token() {
    return this.definition.clientToken;
  }
}

export default PaymentProcessorClientTokens;
